/**
 * The wording the session gate shows in place of a participant-only page.
 */

/** Shown while a stored session is still being restored. */
export const CHARITY_SESSION_RESTORING_MESSAGE = "Restoring your session…";

/** Shown once the visitor is known to have no session at all. */
export const CHARITY_SIGN_IN_REQUIRED_MESSAGE = "Please sign in first";

/** Label on the header control that ends the session. */
export const CHARITY_SIGN_OUT_LABEL = "Log out";
